export enum ModalTitulosEnum {
    ErroRadicacion = 'Error en radicación de solicitud',
    ConsultaExitosa = '¡Consulta exitosa!',
    Importante = 'Importante',
    ConsultaSinExito = 'Consulta sin éxito',
    UnMomentoPorFavor = 'Un momento por favor'
}